export const modalConstants = {
  SUCCESS_MODAL: "SUCCESS_MODAL",
  ERROR_MODAL: "ERROR_MODAL",
  WARNING_MODAL: "WARNING_MODAL",
  CLOSE_MODAL: "CLOSE_MODAL",
};
